import { NavLink, useLocation } from 'react-router-dom';
import { IconCards, IconBookmark, IconCompass, IconUsers, IconUser } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

const ITEMS = [
  { to: '/', icon: IconCards, key: 'feed' },
  { to: '/shelf', icon: IconBookmark, key: 'shelf' },
  { to: '/topics', icon: IconCompass, key: 'topics' },
  { to: '/friends', icon: IconUsers, key: 'friends' },
  { to: '/profile', icon: IconUser, key: 'profile' },
] as const;

export function BottomNav() {
  const { t } = useTranslation();
  const path = useLocation().pathname;
  // В подписке/онбординге не показываем нижнюю навигацию.
  // На /limit — показываем (правка #4 из «Правки 3.0»).
  if (path.startsWith('/subscription') || path.startsWith('/onboarding')) return null;

  return (
    <nav
      className="sticky bottom-0 bg-white border-t border-text/10"
      style={{
        paddingBottom: 'calc(var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)) + var(--tg-content-safe-area-inset-bottom, 0px))',
        minHeight: 76,
      }}
    >
      <div className="h-full max-w-screen mx-auto flex items-stretch justify-between px-3">
        {ITEMS.map(({ to, icon: Icon, key }) => (
          <NavLink
            key={key}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 flex-1 transition ${
                isActive ? 'text-accent' : 'text-accent-soft'
              }`
            }
          >
            <Icon size={24} stroke={2} />
            <span className="text-[11px] font-medium">{t(`nav.${key}`)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
